var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-overflow-btn',{staticClass:"sortButton",attrs:{"label":_vm.label,"items":_vm.items,"prefix":_vm.label,"dense":""},on:{"input":_vm.filter},model:{value:(_vm.component_value),callback:function ($$v) {_vm.component_value=$$v},expression:"component_value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }